import { DataIcon } from "@/components/icon/DataIcon.tsx";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import type { VmImage } from "@warrenio/api-spec/spec.oats.gen";

export function VmImageIcon({
    image,
    isSelected,
    ...props
}: { image: VmImage | undefined; isSelected?: boolean } & BaseProps) {
    const { icon, is_app_catalog } = image ?? {};

    return icon ? (
        <DataIcon data={icon} mode={is_app_catalog && !isSelected ? "background" : "mask"} {...props} />
    ) : (
        <MaskIcon {...mcn("i-lucide:app-window-mac", props)} />
    );
}
